import React from 'react'
import styled from 'styled-components'
import {
  Text,
  Title,
  Link,
  Button,
  SideSheet,
  LinkPointsDefaultIcon,
  PriceButton,
  Modal,
} from '@ntuctech/tangram-web'
import format from 'date-fns/format'
import Router from 'next/router'
import FoldableSection from '../FoldableSection/FoldableSection'
import CheckoutPaymentSection from '../CheckoutPaymentSection/CheckoutPaymentSection'
import { CreditCardType } from '../Payment/CreditCardType'

const BenefitRowWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
`
const BenefitIcon = styled.div`
  background-image: url(${props => props.url});
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100%;
  width: 2.5rem;
  height: 2.5rem;
  margin-right: 1rem;
`

const SideSheetFooterButton = styled(Button)`
  width: 100%;
`

const SidesheetUpgradePrompt = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f1f5fd;
  border-radius: 0.25rem;
  padding: 0.75rem;
`

const SidesheetUpgradeButton = styled(Button)`
  padding: 0;
  min-height: 0;
`
const CancelMembershipUsedBenefits = styled.div`
  display: flex;
  align-items: center;
`

const LinkpointIconSc = styled(LinkPointsDefaultIcon)`
  width: 1.5rem;
  height: 1.5rem;
  margin-right: 0.25rem;
`

const SideSheetUpgradeSection = styled.div`
  display: flex;
  justify-content: space-between;
  border-radius: 0.75rem;
  background: #f1f5fd;
  padding: 1rem;
  position: relative;
`

const BasketCointSc = styled.img`
  position: absolute;
  right: 0px;
  bottom: 0px;
`

const UsageSection = styled.div`
  border-radius: 0.75rem;
  background: #fff6f0;
  padding: 1rem;
  margin: 1.5rem 0;
`

const CancelMembershipFooterButton = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
`

const ReactivateMembershipSection = styled.div`
  width: 21.5rem;
  background: #e8eefc;
  border-radius: 0.5rem;
  padding: 1rem;
  margin-bottom: 1.5rem;

  @media (max-width: 768px) {
    width: auto;
    max-width: 20.5rem;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 1rem;
  }
`
const PaymentTitle = styled.div`
  display: flex;
`

const ErrModalCloseButton = styled(Button)`
  width: 100%;
`

export const BenefitRowContent = ({ benefit }) => {
  return (
    <BenefitRowWrapper key={benefit.title}>
      <BenefitIcon url={benefit.imageUrl} />
      <div>
        <Title size="s">{benefit.title}</Title>
        {benefit.hyperlinkUrl ? (
          <Link standalone href={benefit.hyperlinkUrl}>
            {benefit.hyperlinkText}
          </Link>
        ) : (
          <Text size="s">{benefit.description}</Text>
        )}
      </div>
    </BenefitRowWrapper>
  )
}

export const ViewBenefitSideSheet = ({
  headerTitle,
  openBenefitSideSheet,
  setHandleOpenBenefitSideSheet,
  benefitArr,
  showUpgradeCta,
  upgradetext,
}) => {
  return (
    <SideSheet
      open={openBenefitSideSheet}
      onOpenChange={setHandleOpenBenefitSideSheet}
    >
      <SideSheet.Header title={headerTitle} />
      <SideSheet.Body>
        {benefitArr.map(benefit => {
          return (
            <BenefitRowContent benefit={benefit} key={benefit.description} />
          )
        })}
        {showUpgradeCta && (
          <SidesheetUpgradePrompt>
            <Text size="s" bold>
              {upgradetext}
            </Text>
            <SidesheetUpgradeButton
              onClick={() =>
                Router.push(`/membership/checkout?planId=7&isChangePlan=true`)
              }
            >
              Upgrade
            </SidesheetUpgradeButton>
          </SidesheetUpgradePrompt>
        )}
      </SideSheet.Body>
      <SideSheet.Footer>
        <SideSheetFooterButton
          variant="primary"
          onClick={() => setHandleOpenBenefitSideSheet(false)}
        >
          Ok got it
        </SideSheetFooterButton>
      </SideSheet.Footer>
    </SideSheet>
  )
}

export const CancelMembershipSideSheet = ({
  openCancelMemSideSheet,
  setOpenCancelMemSideSheet,
  triggerMembershipCancellation,
  dcMembership,
  dateFormat,
  accountData,
  setIsAutoRenewal,
  getMembership,
  setDcMembership,
  setShowSurveyPopup,
  showUpgradeCta,
  setOpenErrModal,
  setErr,
}) => {
  const HandleTitleText = () => {
    if (dcMembership.freetrial) {
      return (
        <Title size="s">
          If you confirm, your free trial will end on{' '}
          {format(
            new Date(dcMembership?.membership?.endDate.slice(0, -1)),
            dateFormat
          )}{' '}
        </Title>
      )
    } else if (!dcMembership.freetrial && !dcMembership.benefit.immediate) {
      return (
        <Title size="s">
          If you confirm, your membership will end on{' '}
          {format(
            new Date(dcMembership?.membership?.endDate.slice(0, -1)),
            dateFormat
          )}{' '}
        </Title>
      )
    } else {
      return (
        <Title size="s">
          If you confirm, your membership will end immediately.
        </Title>
      )
    }
  }
  const [loading, setLoading] = React.useState(false)
  return (
    <SideSheet
      open={openCancelMemSideSheet}
      onOpenChange={setOpenCancelMemSideSheet}
    >
      <SideSheet.Header title={'Cancel membership'} />
      <SideSheet.Body>
        <div style={{ marginBottom: '0.5rem' }}>
          <HandleTitleText />
        </div>
        <div>
          {!dcMembership.freetrial &&
          dcMembership?.benefit?.linkPointsAwarded === '0.00' ? (
            <Text>
              {`$${
                dcMembership?.amount
              } will be refunded to your credit card since you haven’t
              utilised any membership benefits. Thereafter, you will no longer
              have access to membership benefits.${' '}`}
            </Text>
          ) : (
            <Text size="m">
              Thereafter, you will no longer have access to membership benefits.
            </Text>
          )}
        </div>
        <UsageSection>
          <div style={{ marginBottom: '0.5rem' }}>
            <Title size="xs">
              Your benefits since{' '}
              {format(dcMembership?.membership?.startDate, dateFormat)}
            </Title>
          </div>
          <CancelMembershipUsedBenefits style={{ marginBottom: '0.5rem' }}>
            <img
              src="https://media.nedigital.sg/fairprice/files/27695f1a-c9ff-4ed3-a1f1-7fcd7fc4b323/Coin_yellow.svg"
              style={{ marginRight: '0.25rem' }}
            />
            <Text>
              <b>${dcMembership?.benefit?.amountSaved}</b> saved
            </Text>
          </CancelMembershipUsedBenefits>
          <CancelMembershipUsedBenefits>
            <LinkpointIconSc />
            <Text>
              <b>{dcMembership?.benefit?.linkPointsAwarded}</b> Earned
            </Text>
          </CancelMembershipUsedBenefits>
        </UsageSection>
        {showUpgradeCta && (
          <SideSheetUpgradeSection>
            <div>
              <div>
                <Title size="xs">
                  {dcMembership?.ui?.upgradePlan?.benefitUpgradeText}
                </Title>
              </div>
              <div>
                <Text>{dcMembership?.ui?.upgradePlan?.subTitle}</Text>
              </div>
              <Button
                style={{ marginTop: '1rem' }}
                variant="secondary"
                onClick={() =>
                  Router.push(`/membership/checkout?planId=7&isChangePlan=true`)
                }
              >
                Change plan
              </Button>
            </div>
            <BasketCointSc src="https://media.nedigital.sg/fairprice/files/78320051-c983-464d-a6f2-d9e01c6f5e94/basket_coins.svg" />
          </SideSheetUpgradeSection>
        )}
      </SideSheet.Body>
      <SideSheet.Footer>
        <CancelMembershipFooterButton>
          <Button
            variant="primary-destructive"
            loading={loading}
            onClick={() => {
              triggerMembershipCancellation({
                accountData,
                membershipAccount: dcMembership,
                setIsAutoRenewal,
                getMembershipFunc: getMembership,
                setDcMembership,
                setOpenCancelMemSideSheet,
                setLoading,
                setShowSurveyPopup,
                setOpenErrModal,
                setErr,
              })
            }}
          >
            Cancel membership
          </Button>
          <Button
            variant="secondary"
            onClick={() => setOpenCancelMemSideSheet(false)}
          >
            Keep membership
          </Button>
        </CancelMembershipFooterButton>
      </SideSheet.Footer>
    </SideSheet>
  )
}

export const ReactivateMembership = ({
  dateFormat,
  handleReactivateMembership,
  dcMembership,
  defaultCard,
  getMembership,
  setDcMembership,
  setIsAutoRenewal,
  setOpenErrModal,
  setErr,
  setShowReactivationToast,
}) => {
  const [loading, setLoading] = React.useState(false)
  return (
    <ReactivateMembershipSection>
      <div style={{ marginBottom: '0.75rem' }}>
        <Text size="m">
          Your FairPrice Digital Club membership will end on{' '}
        </Text>
        <Text bold>
          {format(
            new Date(dcMembership?.membership?.endDate.slice(0, -1)),
            dateFormat
          )}
          .
        </Text>
      </div>
      <Button
        variant="primary"
        loading={loading}
        onClick={() => {
          handleReactivateMembership({
            dcMembership,
            defaultCard,
            getMembershipFunc: getMembership,
            setDcMembership,
            setIsAutoRenewal,
            setLoading,
            setOpenErrModal,
            setErr,
            setShowReactivationToast,
          })
        }}
      >
        Reactivate membership
      </Button>
    </ReactivateMembershipSection>
  )
}

export const MembershipCheckoutPaymentsComp = ({
  selectedCreditCard,
  isUserCardChanged,
  defaultCard,
  setSelectedCreditCard,
  setIsUserCardChanged,
  loading,
  programDetails,
  getSelectedPackage,
  handleSubmit,
  setLoading,
  setIsOtpRequired,
  setIsPaymentFailed,
  handleAutoRenewal,
  isChangePlan,
  packageId,
  router,
}) => {
  return (
    <>
      <div style={{ marginBottom: '0.75rem' }}>
        <Title size="s">Your payment method</Title>
      </div>
      <FoldableSection
        title={
          !!selectedCreditCard && !!isUserCardChanged ? (
            <PaymentTitle>
              <CreditCardType
                number={selectedCreditCard.number}
                type={selectedCreditCard.type}
              />
              <div style={{ marginLeft: '0.5rem' }}>
                <Text size="medium" weight="bold">
                  &bull;&bull;&bull;&bull;
                  {selectedCreditCard.number.substr(-4)}
                </Text>
              </div>
            </PaymentTitle>
          ) : (
            'Payment'
          )
        }
        isInitiallyOpened={!isUserCardChanged}
        isDisabled={false}
        onExpand={() => {
          setIsUserCardChanged(false)
        }}
      >
        <CheckoutPaymentSection
          isUserCardChanged={isUserCardChanged}
          defaultCard={defaultCard}
          isMemberShipFlowEnabled={true}
          onChange={({ paymentData: { selectedCard } }) => {
            setSelectedCreditCard(selectedCard)
            setIsUserCardChanged(!!selectedCard)
          }}
        />
      </FoldableSection>
      <PriceButton
        loading={loading}
        disabled={!selectedCreditCard || loading}
        label={
          programDetails?.isFreeTrialEligible
            ? 'Start free trial'
            : 'Subscribe now'
        }
        amount={
          programDetails?.isFreeTrialEligible ? 0 : getSelectedPackage?.price
        }
        onClick={() => {
          isChangePlan
            ? handleAutoRenewal({
                membershipId: programDetails?.membership?.cardNumber,
                selectedCreditCard,
                packageId,
                setLoading,
                setIsPaymentFailed,
                router,
              })
            : handleSubmit(
                selectedCreditCard,
                getSelectedPackage?.id,
                setLoading,
                setIsOtpRequired,
                setIsPaymentFailed
              )
        }}
      />
    </>
  )
}

export const DigitalClubErrorModal = ({
  open,
  setOpen,
  errorTitle,
  errorMessage,
  setErr,
  isPaymentErr,
}) => {
  const handleClose = () => {
    setOpen(false)
    setErr && setErr(null)
  }

  return (
    <Modal open={open} onOpenChange={setOpen}>
      {isPaymentErr && (
        <div>
          <img
            width="100%"
            src="https://media.nedigital.sg/fairprice/files/70191b1a-09c7-4f1f-95c2-5d138ac523e9/Payment_failure.svg"
          />
        </div>
      )}
      <Modal.Title>{errorTitle}</Modal.Title>
      <Modal.Body>
        <div>{errorMessage}</div>
      </Modal.Body>

      <Modal.Footer orientation="horizontal">
        <Modal.Action>
          <ErrModalCloseButton onClick={handleClose}>Close</ErrModalCloseButton>
        </Modal.Action>
      </Modal.Footer>
    </Modal>
  )
}

export const getCurrPlanType = membership => {
  if (membership?.freetrial) {
    return 'free trial'
  } else if (membership?.recurrentType === 'Monthly') {
    return 'monthly'
  } else {
    return 'annual'
  }
}

export const getSideSheetHeaderTitle = recurrentType => {
  if (recurrentType === 'Yearly') {
    return 'Annual plan benefits'
  }
  return 'Monthly plan benefits'
}
